import UIDs from "../../../../UIDs";

const uid = UIDs.screens.account.register;

const ActionTypes = {
    REGISTER_ASYNC: `${uid}.registerAsync`,
    REGISTER_SUCCESS: `${uid}.registerSuccess`,
    REGISTER_FAILURE: `${uid}.registerFailure`    
};

export { ActionTypes };
